// V2 Icon - Re-export from seeds-react-icon for optimal tree shaking
export { Icon, default } from "@sproutsocial/seeds-react-icon/v2";

// Explicit type exports
export type {
  TypeIconV2Props,
  TypeIconV2Size,
} from "@sproutsocial/seeds-react-icon/v2";
